import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class DartAPIService {
  private url: string = "/api/DartAPI";

  constructor(private http: HttpClient) {}

  async importDartDealById(dartDealId: string, projectId?: string): Promise<any> {
    if (!dartDealId || typeof dartDealId !== "string") throw new Error("DART Deal ID should be provided");

    const params: any = {dartDealId};

    if (projectId && typeof projectId === "string") {
      params.projectId = projectId;
    }

    return this.http.get<{success: boolean}>(`${this.url}/import-dart-deal`, {params})
      .pipe(map(json => ({success: !!json.success})))
      .toPromise();
  }
}
